import Svg, { SvgProps, Path } from 'react-native-svg';

const RestaurantTableIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M11 3c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-1.103 0-2 .897-2 2v5a2 2 0 0 0 2 2h2.643l.138-2H13v-5c0-1.103-.897-2-2-2zm-5.898 2c-.591 0-1.056.507-1.002 1.096l.488 5.357A4.995 4.995 0 0 0 7.8 21.672l-.772 3.086a1 1 0 1 0 1.942.484L9.78 22h3.576l.153-2H9.686a3.001 3.001 0 0 1-2.983-2.67L6.1 11.895A1.004 1.004 0 0 0 5.102 11zm12.76 1a2 2 0 0 0-1.995 1.857L15 26h11V12h-8.139z" />
  </Svg>
);

export default RestaurantTableIcon;
